import "regenerator-runtime/runtime";
import _asyncToGenerator from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import { apolloClient } from '@/apollo/apolloClient';
import { MY_AVATAR } from '@/apollo/queries/user-query';
import { auth } from 'firebase';
var realTimeStore = {
  getters: {
    // gettersには メソッドを記述
    getMyAvatar: function getMyAvatar(state) {
      return state.myAvatar;
    }
  },
  state: {
    myAvatar: ''
  },
  mutations: {
    MY_AVATAR_CREATE: function MY_AVATAR_CREATE(state, value) {
      state.myAvatar = value;
    }
  },
  actions: {
    getMyAvatarAction: function () {
      var _getMyAvatarAction = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref) {
        var commit, state, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, state = _ref.state;
                _context.next = 3;
                return apolloClient.query({
                  query: MY_AVATAR,
                  variables: {
                    my_uid: auth().currentUser.uid
                  }
                });

              case 3:
                res = _context.sent;

                if (!res.errors) {
                  _context.next = 6;
                  break;
                }

                throw res.errors[0].message;

              case 6:
                commit('MY_AVATAR_CREATE', res.data.user.avatar);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getMyAvatarAction(_x) {
        return _getMyAvatarAction.apply(this, arguments);
      }

      return getMyAvatarAction;
    }()
  }
};
export default realTimeStore;